import type { Movie } from "@/types/movie";

export const movies: Movie[] = [
  {
    id: "interstellar-journey",
    title: "星际征途",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%20of%20a%20lone%20astronaut%20facing%20a%20glowing%20ringed%20planet%2C%20deep%20navy%20space%20background%20with%20warm%20orange%20nebula%20light%2C%20dramatic%20volumetric%20lighting%2C%20film%20grain%2C%20professional%20key%20art%2C%20highly%20detailed%20composition&width=600&height=900&seq=qx-mv-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%20with%20a%20vast%20ringed%20planet%20rising%20over%20a%20dark%20lunar%20surface%2C%20deep%20navy%20tones%20with%20warm%20orange%20horizon%20glow%2C%20volumetric%20starlight%2C%20film%20grain%2C%20atmospheric%20sci-fi%20key%20art&width=1600&height=900&seq=qx-bd-01&orientation=landscape",
    year: 2024,
    region: "美国",
    genres: ["科幻", "冒险"],
    director: "克里斯·诺兰",
    actors: ["艾登·布莱克", "玛拉·斯通", "李维·陈"],
    rating: 9.1,
    heat: 9860,
    releaseDate: "2024-08-16",
    duration: "156分钟",
    tagline: "穿越星海，只为找到回家的坐标",
    synopsis:
      "地球资源枯竭之际，一支由顶尖科学家组成的探险队穿越虫洞，前往未知星系寻找人类新的栖息地。在漫长的星际航行中，他们要面对时间的扭曲、人性的考验，以及宇宙深处无法解释的未知信号。",
    tags: ["年度期待", "硬科幻", "IMAX"],
    featured: true,
  },
  {
    id: "changan-night",
    title: "长安夜行",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20historical%20Chinese%20mystery%20movie%20poster%20of%20a%20cloaked%20figure%20walking%20through%20a%20misty%20ancient%20lantern-lit%20street%20at%20night%2C%20deep%20navy%20and%20warm%20amber%20tones%2C%20ink%20wash%20texture%2C%20dramatic%20lighting%2C%20professional%20key%20art&width=600&height=900&seq=qx-mv-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20capital%20city%20at%20night%20with%20countless%20warm%20lanterns%20and%20misty%20rooftops%2C%20deep%20navy%20sky%20with%20amber%20glow%2C%20ink%20painting%20atmosphere%2C%20cinematic%20historical%20drama%20key%20art&width=1600&height=900&seq=qx-bd-02&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["悬疑", "古装"],
    director: "顾长movie",
    actors: ["沈砚", "苏晚晴", "周慕白"],
    rating: 8.7,
    heat: 9230,
    releaseDate: "2024-07-05",
    duration: "132分钟",
    tagline: "一夜长安，真相藏在最亮的灯下",
    synopsis:
      "盛唐年间，长安城接连发生离奇命案。一名被贬的小吏与一位神秘的民间画师联手追查，线索却指向一场足以动摇朝局的阴谋。真相层层揭开，每个人都在夜色的灯影里隐藏着自己的秘密。",
    tags: ["古装悬疑", "高口碑", "强剧情"],
    featured: true,
  },
  {
    id: "deep-sea-eye",
    title: "深海之瞳",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20underwater%20suspense%20movie%20poster%20of%20a%20diver%20silhouette%20descending%20into%20a%20dark%20abyss%20with%20a%20faint%20glowing%20eye%20in%20the%20depths%2C%20deep%20navy%20teal%20with%20cool%20cyan%20light%2C%20dramatic%20atmosphere%2C%20professional%20key%20art&width=600&height=900&seq=qx-mv-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Vast%20deep%20ocean%20trench%20with%20mysterious%20bioluminescent%20lights%20and%20a%20small%20submarine%20descending%2C%20deep%20navy%20and%20teal%20tones%2C%20cascading%20god%20rays%20from%20surface%2C%20cinematic%20underwater%20mystery%20key%20art&width=1600&height=900&seq=qx-bd-03&orientation=landscape",
    year: 2023,
    region: "中国大陆",
    genres: ["科幻", "悬疑"],
    director: "林澈",
    actors: ["方远", "程知夏", "许铮"],
    rating: 8.4,
    heat: 8410,
    releaseDate: "2023-11-24",
    duration: "118分钟",
    tagline: "海面之下，从没有人真正回来过",
    synopsis:
      "一支深潜科考队在马里亚纳海沟发现不明信号源。随着下潜深度不断增加，队员们的记忆开始出现紊乱，海底深处似乎有某种存在正注视着他们。当科学的边界被打破，恐惧便有了形状。",
    tags: ["深海", "烧脑", "氛围感"],
    featured: false,
  },
  {
    id: "chasing-wind",
    title: "追风者",
    poster:
      "https://readdy.ai/api/search-image?query=High%20energy%20action%20movie%20poster%20of%20a%20motorcyclist%20leaning%20into%20a%20sharp%20turn%20with%20sparks%20flying%2C%20deep%20navy%20night%20city%20with%20warm%20orange%20streetlight%20streaks%2C%20motion%20blur%2C%20cinematic%20key%20art%2C%20highly%20detailed&width=600&height=900&seq=qx-mv-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Rain-slicked%20night%20city%20street%20with%20a%20speeding%20motorcycle%20leaving%20orange%20light%20trails%2C%20deep%20navy%20buildings%2C%20reflective%20wet%20asphalt%2C%20cinematic%20action%20thriller%20key%20art&width=1600&height=900&seq=qx-bd-04&orientation=landscape",
    year: 2024,
    region: "中国香港",
    genres: ["动作", "犯罪"],
    director: "陈嘉恒",
    actors: ["郑浩", "何静仪", "麦子豪"],
    rating: 8.2,
    heat: 8870,
    releaseDate: "2024-06-19",
    duration: "110分钟",
    tagline: "速度是他唯一听得懂的语言",
    synopsis:
      "曾叱咤地下赛道的车手因一场事故退出江湖，多年后为营救被卷入案件的弟弟，他被迫重返危险的夜晚。在警队与人贩之间，他要用一场极限竞速换回最后的清白。",
    tags: ["飙车", "港味", "爽片"],
    featured: true,
  },
  {
    id: "tender-years",
    title: "温柔岁月",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20romantic%20drama%20movie%20poster%20of%20two%20figures%20standing%20apart%20on%20a%20quiet%20seaside%20promenade%20at%20golden%20hour%2C%20soft%20warm%20orange%20and%20muted%20navy%20tones%2C%20gentle%20film%20grain%2C%20delicate%20emotional%20composition&width=600&height=900&seq=qx-mv-05&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Quiet%20seaside%20town%20promenade%20at%20golden%20sunset%20with%20soft%20warm%20orange%20light%20and%20muted%20navy%20shadows%2C%20gentle%20romantic%20drama%20key%20art%2C%20nostalgic%20film%20grade&width=1600&height=900&seq=qx-bd-05&orientation=landscape",
    year: 2022,
    region: "中国台湾",
    genres: ["剧情", "爱情"],
    director: "侯孝慈",
    actors: ["林予安", "陈嘉宁", "吴念真"],
    rating: 8.9,
    heat: 7240,
    releaseDate: "2022-09-30",
    duration: "126分钟",
    tagline: "有些告别，用了整整一生",
    synopsis:
      "在南方的一座临海小镇，一封迟到二十年的信被重新打开。昔日的青梅竹马早已各奔东西，唯有海边那家老唱片店还留着他们共同的夏天。岁月温柔，却也残忍。",
    tags: ["文艺", "治愈", "催泪"],
    featured: false,
  },
  {
    id: "dark-night-detective",
    title: "暗夜侦探",
    poster:
      "https://readdy.ai/api/search-image?query=Moody%20crime%20noir%20movie%20poster%20of%20a%20detective%20in%20a%20trench%20coat%20under%20a%20flickering%20streetlamp%2C%20rainy%20dark%20navy%20alley%20with%20a%20single%20warm%20orange%20light%2C%20smoke%20and%20fog%2C%20high%20contrast%20cinematic%20key%20art&width=600&height=900&seq=qx-mv-06&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Rainy%20dark%20city%20alley%20at%20night%20with%20isolated%20warm%20orange%20streetlamps%20and%20deep%20navy%20shadows%2C%20wet%20reflective%20ground%2C%20crime%20thriller%20noir%20key%20art&width=1600&height=900&seq=qx-bd-06&orientation=landscape",
    year: 2024,
    region: "韩国",
    genres: ["犯罪", "悬疑"],
    director: "朴正勋",
    actors: ["金道贤", "李瑞妍", "崔宇成"],
    rating: 8.6,
    heat: 8620,
    releaseDate: "2024-04-12",
    duration: "124分钟",
    tagline: "当所有人都在说谎，只有证据不会",
    synopsis:
      "一名因旧案被停职的刑警，在雨夜接到匿名来电。随着调查深入，他发现十年前那桩悬案与当下的连环案件有着惊人的联系。真相藏在城市的阴影里，也藏在他自己的记忆深处。",
    tags: ["犯罪", "反转", "高能"],
    featured: false,
  },
  {
    id: "coastline",
    title: "海岸线",
    poster:
      "https://readdy.ai/api/search-image?query=Minimalist%20Japanese%20drama%20movie%20poster%20of%20a%20lone%20figure%20walking%20along%20a%20misty%20shoreline%20at%20dawn%2C%20muted%20navy%20sea%20and%20soft%20pale%20light%2C%20subtle%20grain%2C%20restrained%20elegant%20composition&width=600&height=900&seq=qx-mv-07&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Misty%20shoreline%20at%20dawn%20with%20calm%20muted%20navy%20sea%20and%20pale%20soft%20sky%2C%20minimalist%20Japanese%20drama%20atmosphere%2C%20serene%20and%20restrained%20cinematic%20key%20art&width=1600&height=900&seq=qx-bd-07&orientation=landscape",
    year: 2021,
    region: "日本",
    genres: ["剧情", "家庭"],
    director: "是枝裕和",
    actors: ["高桥悠", "中村千夏", "小林彻"],
    rating: 8.8,
    heat: 6350,
    releaseDate: "2021-10-08",
    duration: "121分钟",
    tagline: "海会记得每一个归来的脚步",
    synopsis:
      "在小渔村经营旅馆的母亲突然病倒，远在都市打拼的子女不得不回到久违的故乡。三代人之间未说出口的歉意与牵挂，在潮起潮落里慢慢被冲上岸。",
    tags: ["家庭", "温情", "细腻"],
    featured: false,
  },
  {
    id: "silent-confession",
    title: "无声告白",
    poster:
      "https://readdy.ai/api/search-image?query=Intimate%20social%20drama%20movie%20poster%20of%20a%20girl%20seen%20through%20rain-streaked%20glass%20with%20a%20hand%20pressed%20against%20it%2C%20deep%20navy%20and%20warm%20amber%20accents%2C%20emotional%20cinematic%20key%20art&width=600&height=900&seq=qx-mv-08&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Empty%20school%20corridor%20at%20dusk%20with%20long%20warm%20orange%20light%20and%20deep%20navy%20shadows%2C%20quiet%20melancholic%20social%20drama%20key%20art%2C%20soft%20film%20grain&width=1600&height=900&seq=qx-bd-08&orientation=landscape",
    year: 2023,
    region: "中国大陆",
    genres: ["剧情"],
    director: "文晏",
    actors: ["张若宁", "章宇", "谭卓"],
    rating: 8.5,
    heat: 6890,
    releaseDate: "2023-03-17",
    duration: "115分钟",
    tagline: "最深的呐喊，往往是无声的",
    synopsis:
      "一名沉默寡言的少女用画笔记录下身边发生的一切。当她的画作被展出，那些被忽视的真相与伤痛终于被看见。影片以克制的镜头语言，讲述一个关于勇气与救赎的故事。",
    tags: ["现实主义", "女性题材", "口碑"],
    featured: false,
  },
  {
    id: "wilderness-echo",
    title: "荒野回声",
    poster:
      "https://readdy.ai/api/search-image?query=Western%20adventure%20movie%20poster%20of%20a%20lone%20horseman%20riding%20across%20a%20vast%20desert%20mesa%20at%20sunset%2C%20deep%20navy%20mountains%20with%20warm%20orange%20sky%2C%20dusty%20atmosphere%2C%20cinematic%20key%20art&width=600&height=900&seq=qx-mv-09&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Vast%20desert%20canyon%20at%20sunset%20with%20deep%20navy%20rock%20formations%20and%20warm%20orange%20sky%2C%20dust%20and%20lonely%20trail%2C%20epic%20western%20adventure%20key%20art&width=1600&height=900&seq=qx-bd-09&orientation=landscape",
    year: 2022,
    region: "美国",
    genres: ["冒险", "剧情"],
    director: "杰克·哈里森",
    actors: ["伊森·里德", "娜奥米·科尔", "山姆·华莱士"],
    rating: 8.0,
    heat: 6120,
    releaseDate: "2022-05-20",
    duration: "134分钟",
    tagline: "有些路，只能一个人走",
    synopsis:
      "内战结束后，一名退伍军人独自踏上穿越蛮荒西部的旅程，只为完成对亡友的承诺。在荒野中他遇到形形色色的人，也逐渐与自己的过去和解。",
    tags: ["西部", "冒险", "史诗"],
    featured: false,
  },
  {
    id: "city-lights",
    title: "城市之光",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20city%20drama%20movie%20poster%20of%20two%20silhouettes%20on%20a%20Paris%20balcony%20at%20night%20with%20warm%20orange%20window%20glow%20and%20deep%20navy%20rooftops%2C%20dreamy%20cinematic%20key%20art&width=600&height=900&seq=qx-mv-10&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=European%20city%20rooftops%20at%20night%20with%20countless%20warm%20orange%20windows%20against%20deep%20navy%20sky%2C%20romantic%20atmosphere%2C%20cinematic%20drama%20key%20art&width=1600&height=900&seq=qx-bd-10&orientation=landscape",
    year: 2024,
    region: "法国",
    genres: ["爱情", "剧情"],
    director: "克拉拉·莫罗",
    actors: ["卢卡斯·贝尔", "艾米莉·拉方", "皮埃尔·杜邦"],
    rating: 8.3,
    heat: 7020,
    releaseDate: "2024-02-14",
    duration: "108分钟",
    tagline: "在千万盏灯里，我只认得出你的那一盏",
    synopsis:
      "一位街头小提琴手与一位失眠的译者，在巴黎的夜里反复相遇。他们交换彼此的故事，却始终没有留下名字。当城市灯火亮起，爱情也许是唯一不需要翻译的语言。",
    tags: ["爱情", "文艺", "浪漫"],
    featured: false,
  },
  {
    id: "time-traveler",
    title: "时间旅行者",
    poster:
      "https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20poster%20of%20a%20man%20standing%20before%20a%20vast%20glowing%20clockwork%20portal%2C%20deep%20navy%20blue%20with%20warm%20orange%20energy%20accents%2C%20intricate%20detail%2C%20cinematic%20key%20art&width=600&height=900&seq=qx-mv-11&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Surreal%20cosmic%20clockwork%20portal%20with%20swirling%20deep%20navy%20and%20warm%20orange%20energy%2C%20gears%20and%20light%20trails%2C%20time%20travel%20science%20fiction%20key%20art&width=1600&height=900&seq=qx-bd-11&orientation=landscape",
    year: 2023,
    region: "英国",
    genres: ["科幻", "爱情"],
    director: "奥利弗·格林",
    actors: ["亨利·亚当斯", "萝丝·泰勒", "丹尼尔·怀特"],
    rating: 8.4,
    heat: 7780,
    releaseDate: "2023-12-01",
    duration: "122分钟",
    tagline: "如果时间可以重来，你会选择哪一次告别",
    synopsis:
      "物理学家发明了一台只能前进、无法后退的时间装置。为了挽回一场意外，他一次次跳向未来，却发现每改变一个瞬间，都会失去另一段珍贵的记忆。",
    tags: ["时间", "软科幻", "感人"],
    featured: false,
  },
  {
    id: "homeward",
    title: "归途",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20family%20drama%20movie%20poster%20of%20an%20elderly%20father%20and%20adult%20son%20walking%20a%20country%20road%20at%20dusk%2C%20deep%20navy%20hills%20with%20warm%20orange%20sky%2C%20tender%20cinematic%20key%20art&width=600&height=900&seq=qx-mv-12&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Country%20road%20winding%20through%20deep%20navy%20hills%20under%20a%20warm%20orange%20dusk%20sky%2C%20homecoming%20atmosphere%2C%20tender%20family%20drama%20key%20art&width=1600&height=900&seq=qx-bd-12&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["剧情", "家庭"],
    director: "王小帅",
    actors: ["陈建斌", "咏梅", "黄尧"],
    rating: 8.6,
    heat: 7310,
    releaseDate: "2024-01-26",
    duration: "128分钟",
    tagline: "回家的路再远，也值得走一次",
    synopsis:
      "在外打工二十年的老张终于决定返乡过年，一路上他遇到同样漂泊的人们。故乡的样貌早已改变，唯一不变的是母亲留在门前的灯。一封迟到的家书，串起两代人的和解。",
    tags: ["春节档", "亲情", "感动"],
    featured: false,
  },
  {
    id: "crimson-dawn",
    title: "血色黎明",
    poster:
      "https://readdy.ai/api/search-image?query=War%20epic%20movie%20poster%20of%20soldiers%20silhouetted%20against%20a%20burning%20horizon%2C%20deep%20navy%20smoke%20and%20warm%20orange%20fire%20glow%2C%20dramatic%20gritty%20cinematic%20key%20art&width=600&height=900&seq=qx-mv-13&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Battlefield%20at%20dawn%20with%20deep%20navy%20smoke%20clouds%20and%20warm%20orange%20firelight%2C%20epic%20war%20drama%20atmosphere%2C%20gritty%20cinematic%20key%20art&width=1600&height=900&seq=qx-bd-13&orientation=landscape",
    year: 2022,
    region: "中国大陆",
    genres: ["战争", "历史"],
    director: "冯振国",
    actors: ["段奕宏", "张译", "朱亚文"],
    rating: 8.7,
    heat: 7950,
    releaseDate: "2022-08-01",
    duration: "148分钟",
    tagline: "黎明之前，总要有人先站出来",
    synopsis:
      "故事取材于真实历史中的一场关键战役。一支被围困的连队在弹尽粮绝的情况下坚守阵地，用血肉之躯为后续部队赢得时间。战争之下，每个普通人的选择都重于千钧。",
    tags: ["战争", "群像", "热血"],
    featured: false,
  },
  {
    id: "letters-from-mountain",
    title: "山间来信",
    poster:
      "https://readdy.ai/api/search-image?query=Gentle%20arthouse%20movie%20poster%20of%20a%20woman%20reading%20a%20letter%20in%20a%20sunlit%20mountain%20cottage%2C%20muted%20navy%20shadows%20and%20warm%20amber%20sunlight%2C%20quiet%20poetic%20cinematic%20key%20art&width=600&height=900&seq=qx-mv-14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Serene%20mountain%20valley%20with%20morning%20mist%2C%20muted%20navy%20tones%20and%20soft%20warm%20amber%20sunlight%2C%20poetic%20arthouse%20drama%20key%20art&width=1600&height=900&seq=qx-bd-14&orientation=landscape",
    year: 2021,
    region: "日本",
    genres: ["剧情", "文艺"],
    director: "河濑直美",
    actors: ["苍井优", "森山未来", "松隆子"],
    rating: 8.2,
    heat: 5240,
    releaseDate: "2021-06-11",
    duration: "104分钟",
    tagline: "山不会回答，但它一直在听",
    synopsis:
      "一位在城市中失去创作灵感的作家搬进深山的老屋。她开始给一位从未谋面的笔友写信，用文字记录四季更替与内心变化。慢下来的日子，让她重新学会了生活。",
    tags: ["文艺", "慢电影", "自然"],
    featured: false,
  },
  {
    id: "polar-rescue",
    title: "极地营救",
    poster:
      "https://readdy.ai/api/search-image?query=Disaster%20thriller%20movie%20poster%20of%20a%20rescue%20helicopter%20over%20a%20frozen%20ice%20field%20during%20a%20storm%2C%20deep%20navy%20blizzard%20with%20warm%20orange%20signal%20flare%2C%20tense%20cinematic%20key%20art&width=600&height=900&seq=qx-mv-15&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Icy%20polar%20wasteland%20during%20a%20blizzard%20with%20deep%20navy%20storm%20clouds%20and%20warm%20orange%20flare%20light%2C%20tense%20disaster%20rescue%20key%20art&width=1600&height=900&seq=qx-bd-15&orientation=landscape",
    year: 2024,
    region: "中国大陆",
    genres: ["动作", "灾难"],
    director: "高群书",
    actors: ["彭于晏", "辛芷蕾", "王砚辉"],
    rating: 8.1,
    heat: 8560,
    releaseDate: "2024-09-13",
    duration: "126分钟",
    tagline: "在零下四十度，每一秒都是生死",
    synopsis:
      "一场突如其来的暴风雪困住了南极科考站。一支救援队冒着极端天气深入冰原，在与时间赛跑的过程中，他们不仅要对抗自然，也要面对各自内心的恐惧与抉择。",
    tags: ["灾难", "特效", "紧张"],
    featured: false,
  },
  {
    id: "cloud-city",
    title: "云端之城",
    poster:
      "https://readdy.ai/api/search-image?query=Animated%20fantasy%20movie%20poster%20of%20a%20floating%20island%20city%20above%20the%20clouds%20with%20a%20small%20airship%2C%20deep%20navy%20sky%20and%20warm%20orange%20sunset%20glow%2C%20whimsical%20detailed%20illustration&width=600&height=900&seq=qx-mv-16&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Magical%20floating%20island%20city%20above%20a%20sea%20of%20clouds%20at%20sunset%2C%20deep%20navy%20sky%20with%20warm%20orange%20glow%2C%20whimsical%20animated%20fantasy%20key%20art&width=1600&height=900&seq=qx-bd-16&orientation=landscape",
    year: 2023,
    region: "日本",
    genres: ["动画", "奇幻"],
    director: "新海诚",
    actors: ["花泽香菜", "神木隆之介", "有村架纯"],
    rating: 9.0,
    heat: 9450,
    releaseDate: "2023-07-21",
    duration: "112分钟",
    tagline: "只要还记得，故乡就永远不会消失",
    synopsis:
      "少年为了寻找失踪的姐姐，登上了传说中漂浮在云层之上的城市。在这座由记忆构成的城市里，他遇见了形形色色的旅人，也终于明白：真正让人回家的，是牵挂。",
    tags: ["动画", "治愈", "画面美"],
    featured: true,
  },
  {
    id: "youth-parabola",
    title: "青春抛物线",
    poster:
      "https://readdy.ai/api/search-image?query=Energetic%20sports%20coming-of-age%20movie%20poster%20of%20teenagers%20playing%20basketball%20at%20a%20sunset%20outdoor%20court%2C%20deep%20navy%20shadows%20with%20warm%20orange%20light%2C%20youthful%20cinematic%20key%20art&width=600&height=900&seq=qx-mv-17&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Outdoor%20basketball%20court%20at%20sunset%20with%20deep%20navy%20long%20shadows%20and%20warm%20orange%20sky%2C%20youthful%20energetic%20sports%20drama%20key%20art&width=1600&height=900&seq=qx-bd-17&orientation=landscape",
    year: 2022,
    region: "中国大陆",
    genres: ["青春", "运动"],
    director: "张一白",
    actors: ["刘昊然", "周冬雨", "彭昱畅"],
    rating: 7.9,
    heat: 6480,
    releaseDate: "2022-07-15",
    duration: "106分钟",
    tagline: "青春就是那道划破天空的抛物线",
    synopsis:
      "一所普通高中的篮球队在毕业赛季迎来最后的机会。五个性格迥异的少年，为了共同的梦想并肩作战。汗水、友情与遗憾，都留在了那个永不落幕的夏天。",
    tags: ["青春", "热血", "校园"],
    featured: false,
  },
  {
    id: "last-subway",
    title: "最后一班地铁",
    poster:
      "https://readdy.ai/api/search-image?query=Psychological%20thriller%20movie%20poster%20of%20an%20empty%20subway%20car%20with%20a%20lone%20passenger%20and%20flickering%20lights%2C%20deep%20navy%20tunnel%20with%20warm%20orange%20glow%2C%20eerie%20cinematic%20key%20art&width=600&height=900&seq=qx-mv-18&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dark%20empty%20subway%20tunnel%20with%20flickering%20warm%20orange%20lights%20and%20deep%20navy%20shadows%2C%20eerie%20psychological%20thriller%20key%20art&width=1600&height=900&seq=qx-bd-18&orientation=landscape",
    year: 2023,
    region: "韩国",
    genres: ["惊悚", "悬疑"],
    director: "罗泓轸",
    actors: ["李政宰", "全汝彬", "柳俊烈"],
    rating: 8.3,
    heat: 7180,
    releaseDate: "2023-09-08",
    duration: "116分钟",
    tagline: "末班车之后，没有人再下车",
    synopsis:
      "深夜的末班地铁上只剩下五名乘客。列车突然停在黑暗的隧道中，广播响起一段不属于这个时代的录音。当他们试图逃离，才发现自己早已被困在某个无法解释的循环里。",
    tags: ["惊悚", "封闭空间", "氛围"],
    featured: false,
  },
];